import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { AppRouter } from './routes';
import { register } from 'serviceWorker';

ReactDOM.render(<AppRouter />, document.getElementById('root') as HTMLElement);
register();
